/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface PaymentExpirationConfig {
  description?: string;
  enumValue?: PaymentExpirationConfig.EnumValueEnum;
  expirationTime?: number;
  name?: string;
  paymentExpirationConfigId?: number;
}
export namespace PaymentExpirationConfig {
  export type EnumValueEnum =
    | 'CHARGE'
    | 'RECURRENCE'
    | 'ACQUISITION'
    | 'RETENTION'
    | 'RETENTION_CRM';
  export const EnumValueEnum = {
    CHARGE: 'CHARGE' as EnumValueEnum,
    RECURRENCE: 'RECURRENCE' as EnumValueEnum,
    ACQUISITION: 'ACQUISITION' as EnumValueEnum,
    RETENTION: 'RETENTION' as EnumValueEnum,
    RETENTIONCRM: 'RETENTION_CRM' as EnumValueEnum
  };
}
